// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"6ae20f68","787":"dd8e76af"}[chunkId] + ".chunk.js";
};